import isEmpty from 'lodash.isempty';
import { Container, Row, Col } from '@geberit/gdds';

// styles
import styles from './jobs.module.scss';

// components
import { JobTiles } from '../Tiles/job-tile';
import { Headline, FontWeights, Formats } from 'components/ContentElements/Headline';
import { CmsLink } from 'components/Link/CmsLink';

// utils
import { useIsMobile } from 'components/App/SizeProvider';
import { classNameBuilder } from 'utils/classNameBuilder';
import useJobCount from 'utils/hooks/use-jobcount';
import { useKolo } from 'utils/hooks/use-kolo';

export interface JobsProps {
  title: string;
  subtitle: string;
  emphasize: 'title' | 'subtitle';
  label1?: string;
  label2?: string;
  link?: Link;
  backgroundColor?: string;
}

export function Jobs({ backgroundColor = 'white', ...props }: Readonly<JobsProps>) {
  const { label1, label2, link } = props;
  const isMobile = useIsMobile();
  const jobCount = useJobCount();
  const isKolo = useKolo();

  return (
    <div className={classNameBuilder(styles.wrapper, styles[`${backgroundColor}Background`])}>
      {isMobile ? (
        <Container>
          <Row>
            <Col>
              <JobTiles {...props} />
            </Col>
          </Row>
        </Container>
      ) : (
        <Container maxContentWidth="78rem">
          <Row>
            <Col size={[4, 8, 12]} className={styles.border} />
          </Row>
          <Row className={styles.contentRow}>
            <Col size={[4, 4, 5]}>
              <Headline
                tag={Formats.h2}
                format={Formats.h1}
                title={String(jobCount?.vacancies ?? '...')}
                subtitle={label1}
                titleFontWeight={FontWeights.bold}
                subtitleFontWeight={isKolo ? FontWeights.bold : FontWeights.light}
                subtitlePreviewId="#st_label1"
              />
            </Col>
            <Col size={[4, 4, 5]}>
              <Headline
                tag={Formats.h2}
                format={Formats.h1}
                title={String(jobCount?.countries ?? '...')}
                subtitle={label2}
                titleFontWeight={FontWeights.bold}
                subtitleFontWeight={isKolo ? FontWeights.bold : FontWeights.light}
                subtitlePreviewId="#st_label2"
              />
              {!isEmpty(link) && (
                <div className={styles.linkContainer}>
                  <CmsLink link={link} standardFontSize={false} />
                </div>
              )}
            </Col>
          </Row>
          <Row>
            <Col size={[4, 8, 12]} className={styles.border} />
          </Row>
        </Container>
      )}
    </div>
  );
}
